import { useEffect } from "react";

/**
 * Lightweight per-route SEO hook — sets <title>, meta description,
 * canonical, and OG tags without pulling in react-helmet.
 */
export default function useSeo({ title, description, path = "/", noindex = false, ogImage = null }) {
  useEffect(() => {
    if (title) document.title = title;

    const setMeta = (selector, attr, key, value) => {
      let el = document.head.querySelector(selector);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute("content", value);
    };

    if (description) {
      setMeta('meta[name="description"]', "name", "description", description);
      setMeta('meta[property="og:description"]', "property", "og:description", description);
    }
    if (title) {
      setMeta('meta[property="og:title"]', "property", "og:title", title);
    }
    if (ogImage) {
      setMeta('meta[property="og:image"]', "property", "og:image", ogImage);
      setMeta('meta[name="twitter:card"]', "name", "twitter:card", "summary_large_image");
      setMeta('meta[name="twitter:image"]', "name", "twitter:image", ogImage);
    }

    // Canonical
    const canonicalHref = `https://langwood360.com${path}`;
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", canonicalHref);
    setMeta('meta[property="og:url"]', "property", "og:url", canonicalHref);

    // Robots
    setMeta('meta[name="robots"]', "name", "robots", noindex ? "noindex, nofollow" : "index, follow");
  }, [title, description, path, noindex, ogImage]);
}
